// servizi/aggiornamento.ts — v040: il sito si tiene aggiornato da solo.
// Su Android Chrome tiene aperta la scheda per giorni: tornandoci si vede la versione di prima (nei test, due telefoni
// con versioni diverse). Ogni volta che l'app torna in primo piano (e ogni 15 minuti) si chiede la versione al server;
// se il server ne ha una più nuova, la pagina si ricarica appena non si sta giocando. Una sola volta per versione
// (niente giri a vuoto se il server dice una versione che la pagina appena caricata non ha ancora).
// Nelle app (Android/iOS) il codice è dentro l'app: si aggiorna dallo store, qui non si fa niente.
import { caricaImpostazioni, leggiStatoImpostazioni } from "./impostazioni.ts";
import { tempoReale } from "./tempoReale.ts";
import { PIATTAFORMA, PERCORSO_GRUPPO, PERCORSO_SFIDA, PERCORSO_TORNEO, VERSIONE_APP } from "../costanti.ts";
import { piuNuovaDi } from "./versione.ts";

const piuNuova = (server: string | null | undefined) => piuNuovaDi(server, VERSIONE_APP);

const OGNI_MS = 15 * 60_000;
const CHIAVE = "ld.ricaricato_per";

/** Pagine dove una ricarica interromperebbe qualcosa (partita, torneo, partita a 4, video «Riesci a non ridere?»). */
const occupato = (percorso: string): boolean => [PERCORSO_SFIDA, PERCORSO_GRUPPO, PERCORSO_TORNEO, "/v/", "/prova"].some((p) => percorso.startsWith(p));


let attesa: string | null = null;

function ricaricaSeServe(server: string | null | undefined): void {
  if (!piuNuova(server)) return;
  let gia: string | null = null;
  try {
    gia = sessionStorage.getItem(CHIAVE);
  } catch {
    /* niente sessionStorage: si prova lo stesso una volta */
  }
  if (gia === server) return;
  if (occupato(window.location.pathname)) {
    attesa = server!; // si ricarica appena si esce dalla partita
    return;
  }
  try {
    sessionStorage.setItem(CHIAVE, server!);
  } catch {
    /* pazienza */
  }
  window.location.reload();
}

export function avviaAggiornamento(): void {
  if (PIATTAFORMA !== "web") return;
  const controlla = () => void caricaImpostazioni(true).then(() => ricaricaSeServe(leggiStatoImpostazioni().versioneServer));
  document.addEventListener("visibilitychange", () => document.visibilityState === "visible" && controlla());
  // pagina tornata dalla cache «indietro/avanti» del browser: è quella vecchia
  window.addEventListener("pageshow", (e) => (e as PageTransitionEvent).persisted && controlla());
  setInterval(() => document.visibilityState === "visible" && controlla(), OGNI_MS);
  // uscendo dalla partita, se nel frattempo è arrivata una versione nuova
  const dopoNavigazione = () => attesa && !occupato(window.location.pathname) && ricaricaSeServe(attesa);
  window.addEventListener("popstate", dopoNavigazione);
  window.addEventListener("ld:percorso", dopoNavigazione);
  // il server la dice anche quando si collega il tempo reale
  tempoReale.iscrivi(() => ricaricaSeServe(tempoReale.stato.versioneServer));
  ricaricaSeServe(leggiStatoImpostazioni().versioneServer);
}
